export default [
  {
    path: '/repurchaseEasilyList', name: 'repurchaseEasilyList', component: () => import('@/pages/repurchaseEasily/repurchaseEasilyList'), meta: { title: '复购易' },
  },
  {
    path: '/addRepurchaseEasily', name: 'addRepurchaseEasily', component: () => import('@/pages/repurchaseEasily/addRepurchaseEasily'), meta: { title: '复购易' },
  },
  {
    path: '/repurchaseEasilyDetail', name: 'repurchaseEasilyDetail', component: () => import('@/pages/repurchaseEasily/repurchaseEasilyDetail'), meta: { title: '复购易' },
  },
  {
    path: '/repurchaseEasilyIntroduce', name: 'repurchaseEasilyIntroduce', component: () => import('@/pages/repurchaseEasily/repurchaseEasilyIntroduce'), meta: { title: '复购易' },
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/repurchaseEasily.js